module.exports = __webpack_public_path__ + "img/p1.73becb85.png";